"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberWithCircle = NumberWithCircle;
exports.Plain = Plain;
exports.PlainNumber = PlainNumber;

var _material = require("@mui/material");

var _Typography = _interopRequireDefault(require("../../Typography/Typography.overrides"));

var _Typography2 = require("../../Typography");

var _jsxRuntime = require("react/jsx-runtime");

var StyledPlainNumber = (0, _material.styled)(_Typography2.Typography)(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme.palette.brand.grey.stone,
    display: "inline",
    paddingLeft: theme.spacing(2)
  };
});
var StyledCircle = (0, _material.styled)("div")(function (_ref2) {
  var theme = _ref2.theme;
  return {
    alignItems: "center",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "0.5rem",
    display: "inline-flex",
    height: "1rem",
    justifyContent: "center",
    marginLeft: theme.spacing(2),
    minWidth: "1rem",
    padding: "0 0.25rem"
  };
});
var StyledCircleText = (0, _material.styled)(_Typography2.Typography)(function () {
  return {
    color: "white !important",
    fontSize: _Typography.default.MuiTypography.body3.fontSize,
    fontWeight: "bold"
  };
});

/** The intent is to use the plainNumber decoration with a string instead of a node. */
function PlainNumber(_ref3) {
  var text = _ref3.text;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledPlainNumber, {
    component: "span",
    variant: "subtitle2",
    children: ["(", text, ")"]
  });
}
/** The intent is to use the numberWithCircle decoration with a string instead of a node. */


function NumberWithCircle(_ref4) {
  var text = _ref4.text;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCircle, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCircleText, {
      component: "span",
      variant: "subtitle2",
      children: text
    })
  });
}
/** The intent is to use the plain decoration with a node that has been styled elsewhere. */


function Plain(_ref5) {
  var element = _ref5.element;
  return element;
}